import {Action} from '@ngrx/store';
import {AccessRequest} from '../models/access-request';
import { ErrorModel } from '../models/error-model';

export const REQUEST_ACCESS = '[Request] RequestAccess';
export const REQUEST_ACCESS_COMPLETE = '[Request] RequestAccessComplete';
export const LOAD_ACCESS_REQUESTS = '[Request] LoadRequestsForType';
export const LOAD_ACCESS_REQUESTS_COMPLETE = '[Request] LoadRequestsForTypeComplete';
export const APPROVE_ACCESS_REQUEST = '[Request] ApproveAccessRequest';
export const APPROVE_ACCESS_REQUEST_COMPLETE = '[Request] ApproveAccessRequestComplete';
export const DENY_ACCESS_REQUEST = '[Request] DenyAccessRequest';
export const DENY_ACCESS_REQUEST_COMPLETE = '[Request] DenyAccessRequestComplete';
export const CLEAR_ACCESS_REQUEST_SCREEN = '[Request] ClearAccessRequestScreen';

export class RequestAccessAction implements Action {
  readonly type = REQUEST_ACCESS;

  constructor(public payload: AccessRequest) {}
}

export class RequestAccessCompleteAction implements Action {
  readonly type = REQUEST_ACCESS_COMPLETE;

  constructor(public payload: boolean) {}
}

export class LoadAccessRequestsAction implements Action {
  readonly type = LOAD_ACCESS_REQUESTS;

  constructor(public payload: string) {}
}

export class LoadAccessRequestsCompleteAction implements Action {
  readonly type = LOAD_ACCESS_REQUESTS_COMPLETE;

  constructor(public payload: AccessRequest[]) {}
}

export class ApproveAccessRequestAction implements Action {
  readonly type = APPROVE_ACCESS_REQUEST;

  constructor(public payload: AccessRequest) {}
}

export class ApproveAccessRequestCompleteAction implements Action {
  readonly type = APPROVE_ACCESS_REQUEST_COMPLETE;

  constructor(public payload: boolean) {}
}

export class DenyAccessRequestAction implements Action {
  readonly type = DENY_ACCESS_REQUEST;

  constructor(public payload: AccessRequest) {}
}

export class DenyAccessRequestCompleteAction implements Action {
  readonly type = DENY_ACCESS_REQUEST_COMPLETE;

  constructor(public payload: boolean) {}
}

export class ClearAccessRequestScreenAction implements Action {
  readonly type = CLEAR_ACCESS_REQUEST_SCREEN;
}

export type Actions = RequestAccessAction |
  RequestAccessCompleteAction |
  LoadAccessRequestsAction |
  LoadAccessRequestsCompleteAction |
  ApproveAccessRequestAction |
  ApproveAccessRequestCompleteAction |
  DenyAccessRequestAction |
  DenyAccessRequestCompleteAction |
  ClearAccessRequestScreenAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/register.ts